import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class StoreEventNotesService {
  create(params) {
    return securedAxiosInstance.post("/store_event_notes", toSnakeCase(params));
  }
}

export default new StoreEventNotesService();
